import { createSelector } from '@ngrx/store';

import { BackAuthFeatureKey } from './auth.state';
import { getBackState, IBackState } from '../back.state';
export const getBackAuthState = createSelector(
    getBackState,
    (state: IBackState) =>
        state[BackAuthFeatureKey]
);
// export interface IBackAuthState
// {
//     entities: {
//         externalContacts: IUsersState;
//         sites: ISitesState;
//     };
// }

// const initialState: IBackAuthState = {
//     entities: {
//         externalContacts: usersInitialState,
//         sites: sitesInitialState
//     },
// };

// export const BackAuthReducer = createReducer(
//     initialState,
//     on(
//         fromBackAuthStoreActions.BackAuthCountersLoaded,
//         (state: IBackAuthState, { entitiesCounters, usersCounters }) => ({
//             ...state,
//             entities: {
//                 ...state.entities,
//                 external: {
//                     ...state.entities.external,
//                     counters: entitiesCounters.external
//                 },
//                 internal: {
//                     ...state.entities.internal,
//                     counters: entitiesCounters.internal
//                 }
//             },
//             users: {
//                 ...state.users,
//                 external: {
//                     ...state.users.external,
//                     counters: usersCounters.external
//                 },
//                 internal: {
//                     ...state.users.internal,
//                     counters: usersCounters.internal
//                 }
//             }
//         })
//     ),

//     // #region External Entities
//     on(
//         fromBackAuthStoreActions.BackAuthEntitiesExternalODataRequested,
//         (state: IBackAuthState) => ({
//             ...state,
//             entities: {
//                 ...state.entities,
//                 external: {
//                     ...state.entities.external,
//                     isEmpty: false,
//                     isLoading: true,
//                     isLoaded: false,
//                     isOups: false
//                 }
//             }
//         })
//     ),
//     on(
//         fromBackAuthStoreActions.BackAuthEntitiesExternalODataLoaded,
//         (state: IBackAuthState, { entities }) => ({
//             ...state,
//             entities: {
//                 ...state.entities,
//                 external: {
//                     ...state.entities.external,
//                     collection: entitiesAdapter.addMany(entities, state.entities.external.collection),
//                     isEmpty: entities && entities.length === 0,
//                     isLoading: false,
//                     isLoaded: true,
//                     isOups: false,
//                     expirationDate: DateTime.utc().plus({ minutes: BackConstants.DataLifeTime })
//                 }
//             }
//         })
//     ),
//     // #endregion

//     // #region External Users
//     on(
//         fromBackAuthStoreActions.BackAuthUsersExternalODataRequested,
//         (state: IBackAuthState) => ({
//             ...state,
//             users: {
//                 ...state.users,
//                 external: {
//                     ...state.users.external,
//                     isEmpty: false,
//                     isLoading: true,
//                     isLoaded: false,
//                     isOups: false
//                 }
//             }
//         })
//     ),
//     on(
//         fromBackAuthStoreActions.BackAuthUsersExternalODataLoaded,
//         (state: IBackAuthState, { users }) => ({
//             ...state,
//             users: {
//                 ...state.users,
//                 external: {
//                     ...state.users.external,
//                     collection: usersAdapter.setAll(users, state.users.external.collection),
//                     isEmpty: users && users.length === 0,
//                     isLoading: false,
//                     isLoaded: true,
//                     isOups: false,
//                     expirationDate: DateTime.utc().plus({ minutes: BackConstants.DataLifeTime })
//                 }
//             }
//         })
//     ),
//     on(
//         fromBackAuthStoreActions.BackAuthEntityExternalUsersRequested,
//         (state: IBackAuthState) => ({
//             ...state,
//             users: {
//                 ...state.users,
//                 external: {
//                     ...state.users.external,
//                     isEmpty: false,
//                     isLoading: true,
//                     isLoaded: false,
//                     isOups: false
//                 }
//             }
//         })
//     ),
//     on(
//         fromBackAuthStoreActions.BackAuthEntityExternalUsersSucceeded,
//         (state: IBackAuthState, { users }) => ({
//             ...state,
//             users: {
//                 ...state.users,
//                 external: {
//                     ...state.users.external,
//                     collection: usersAdapter.addMany(users, state.users.external.collection),
//                     isLoading: false,
//                     isLoaded: true,
//                     isOups: false
//                 }
//             }
//         })
//     ),
//     // #endregion

//     // #region Internal Entities
//     on(
//         fromBackAuthStoreActions.BackAuthEntitiesInternalODataRequested,
//         (state: IBackAuthState) => ({
//             ...state,
//             entities: {
//                 ...state.entities,
//                 internal: {
//                     ...state.entities.internal,
//                     collection: entitiesInitialState,
//                     isEmpty: false,
//                     isLoading: true,
//                     isLoaded: false,
//                     isOups: false
//                 }
//             }
//         })
//     ),
//     on(

//         fromBackAuthStoreActions.BackAuthEntitiesInternalODataLoaded,
//         (state: IBackAuthState, { entities }) => ({
//             ...state,
//             entities: {
//                 ...state.entities,
//                 internal: {
//                     ...state.entities.internal,
//                     collection: entitiesAdapter.addMany(entities, state.entities.internal.collection),
//                     isEmpty: entities && entities.length === 0,
//                     isLoading: false,
//                     isLoaded: true,
//                     isOups: false,
//                     expirationDate: DateTime.utc().plus({ minutes: BackConstants.DataLifeTime })
//                 }
//             }
//         })
//     ),
//     // #endregion

//     // #region Internal Users
//     on(
//         fromBackAuthStoreActions.BackAuthUsersInternalODataRequested,
//         (state: IBackAuthState) => ({
//             ...state,
//             users: {
//                 ...state.users,
//                 internal: {
//                     ...state.users.internal,
//                     isEmpty: false,
//                     isLoading: true,
//                     isLoaded: false,
//                     isOups: false,
//                 }
//             }
//         })
//     ),
//     on(
//         fromBackAuthStoreActions.BackAuthUsersInternalODataLoaded,
//         (state: IBackAuthState, { users }) => ({
//             ...state,
//             users: {
//                 ...state.users,
//                 internal: {
//                     ...state.users.internal,
//                     collection: usersAdapter.setAll(users, state.users.internal.collection),
//                     isEmpty: users && users.length === 0,
//                     isLoading: false,
//                     isLoaded: true,
//                     isOups: false
//                 }
//             }
//         })
//     ),
//     on(
//         fromBackAuthStoreActions.BackAuthEntityInternalUsersSucceeded,
//         (state: IBackAuthState, { users }) => ({
//             ...state,
//             users: {
//                 ...state.users,
//                 internal: {
//                     ...state.users.internal,
//                     collection: usersAdapter.addMany(users, state.users.internal.collection),
//                     isEmpty: users && users.length === 0,
//                     isLoading: false,
//                     isLoaded: true,
//                     isOups: false
//                 }
//             }
//         })
//     ),
//     // #endregion
//     // #region Selected user
//     on(
//         fromBackAuthStoreActions.BackAuthUserSelectedSet,
//         (state, { user }) => ({
//             ...state,
//             users: {
//                 ...state.users,
//                 selected: {
//                     user
//                 }
//             }
//         })
//     ),
//     on(
//         fromBackAuthStoreActions.BackAuthUserSelectedReset,
//         (state) => ({
//             ...state,
//             users: {
//                 ...state.users,
//                 selected: null
//             }
//         })
//     ),
//     // #endregion
//     on(
//         fromBackAuthStoreActions.BackAuthEntityIdentityUpdated,
//         (state: IBackAuthState, { external, entity }: { external: boolean, entity: Update<Entity> }) =>
//         {
//             const st = {
//                 ...state
//             };

//             if (external)
//             {
//                 st.entities.external.collection = entitiesAdapter.updateOne(entity, state.entities.external.collection);
//             }
//             else
//             {
//                 st.entities.internal.collection = entitiesAdapter.updateOne(entity, state.entities.internal.collection);
//             }

//             return st;
//         }
//     ),
//     on(
//         fromBackAuthStoreActions.BackAuthUserIdentityUpdated,
//         (state: IBackAuthState, { external: external, user: user }: { external: boolean, user: Update<User> }) =>
//         {
//             const st = {
//                 ...state
//             };

//             if (external)
//             {
//                 st.users.external.collection = usersAdapter.updateOne(user, state.users.external.collection);
//             }
//             else
//             {
//                 st.users.internal.collection = usersAdapter.updateOne(user, state.users.internal.collection);
//             }

//             return st;
//         }
//     ),
//     on(
//         fromBackAuthStoreActions.BackAuthEntityExternalContactsSucceeded,
//         (state: IBackAuthState, { users }: { users: User[] }) => ({
//             ...state,
//             entities: {
//                 ...state.entities,
//                 externalContacts: usersAdapter.addAll(users, state.entities.externalContacts)
//             }
//         })
//     ),
//     on(
//         fromBackAuthStoreActions.BackAuthEntitySitesSucceeded,
//         (state: IBackAuthState, { sites }: { sites: Site[] }) => ({
//             ...state,
//             entities: {
//                 ...state.entities,
//                 sites: sitesAdapter.setAll(sites, state.entities.sites)
//             }
//         })
//     ),
//     on(
//         fromBackAuthStoreActions.BackAuthEntitiesCleared,
//         (state: IBackAuthState, { external }) =>
//         {
//             const st = {
//                 ...state
//             };

//             if (external)
//             {
//                 st.entities.external.collection = entitiesAdapter.removeAll(state.entities.external.collection);
//             }
//             else
//             {
//                 st.entities.internal.collection = entitiesAdapter.removeAll(state.entities.internal.collection);
//             }

//             return st;
//         }
//     ),
//     on(
//         fromBackAuthStoreActions.BackAuthUsersCleared,
//         (state: IBackAuthState, { external }) =>
//         {
//             const st = {
//                 ...state
//             };

//             if (external)
//             {
//                 st.users.external.collection = usersAdapter.removeAll(state.users.external.collection);
//             }
//             else
//             {
//                 st.users.internal.collection = usersAdapter.removeAll(state.users.internal.collection);
//             }

//             return st;
//         }
//     ),
//     on(
//         fromBackAuthStoreActions.BackAuthEntitiesExternalQsWordSet,
//         (state, { qsWord }) =>
//         {
//             const st = {
//                 ...state
//             };
//             st.entities.external.qsWord = qsWord.replace(/[-/\\^$*+?.()|[\]{}]/g, '');

//             return st;
//         }
//     ),
//     on(
//         fromBackAuthStoreActions.BackAuthEntitiesExternalQsWordImpeSet,
//         (state, { qsWordImpe }) =>
//         {
//             const st = {
//                 ...state
//             };
//             st.entities.external.qsWordImpe = qsWordImpe.replace(/[-/\\^$*+?.()|[\]{}]/g, '');

//             return st;
//         }
//     ),
//     on(
//         fromBackAuthStoreActions.BackAuthEntitiesInternalQsWordSet,
//         (state, { qsWord }) =>
//         {

//             const st = {
//                 ...state
//             };
//             st.entities.internal.qsWord = qsWord.replace(/[-/\\^$*+?.()|[\]{}]/g, '');

//             return st;
//         }
//     ),
//     on(
//         fromBackAuthStoreActions.BackAuthUsersExternalQsWordSet,
//         (state, { qsWord }) =>
//         {

//             const st = {
//                 ...state
//             };
//             st.users.external.qsWord = qsWord.replace(/[-/\\^$*+?.()|[\]{}]/g, '');

//             return st;
//         }
//     ),
//     on(
//         fromBackAuthStoreActions.BackAuthUsersExternalQsWordImpeSet,
//         (state, { qsWordImpe }) =>
//         {

//             const st = {
//                 ...state
//             };
//             st.users.external.qsWordImpe = qsWordImpe.replace(/[-/\\^$*+?.()|[\]{}]/g, '');

//             return st;
//         }
//     ),
//     on(
//         fromBackAuthStoreActions.BackAuthUsersInternalQsWordSet,
//         (state, { qsWord }) =>
//         {

//             const st = {
//                 ...state
//             };
//             st.users.internal.qsWord = qsWord.replace(/[-/\\^$*+?.()|[\]{}]/g, '');

//             return st;
//         }
//     )
// );
